import {
  IUpdateProgramTemplateCommand,
  ProgramTemplatesVm,
} from "@growth-machine-llc/stridist-api-client";
import ProgramTemplatesService from "../services/ProgramTemplatesService";
import { COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY } from "../components/program-library/ProgramsTableScreen";
import { useOptimisticUpdateMutation } from "./useOptimisticUpdateMutation";

export function useUpdateTemplateCategoryMutation() {
  const { mutate: updateTemplateCategory } = useOptimisticUpdateMutation({
    mutationFn: ProgramTemplatesService.updateProgramTemplate,
    queryKey: [COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY],
    optimisticUpdater: {
      updateFn: (
        oldData: ProgramTemplatesVm,
        variables: IUpdateProgramTemplateCommand,
      ) => {
        if (!oldData?.programTemplates) return oldData;
        return ProgramTemplatesVm.fromJS({
          ...oldData,
          programTemplates: oldData.programTemplates.map((t) =>
            t.id === variables.id ? { ...t, category: variables.category } : t,
          ),
        });
      },
    },
    successToastMessage: "Program template category updated successfully.",
  });

  return { updateTemplateCategory };
}
